<template>
	<v-card>
		<v-card-title class="d-flex align-center mb-4">
			<v-icon
				icon="$users"
				start
			/>
			<translate>Resellers</translate>
			<v-spacer />
			<v-btn
				color="primary"
				variant="flat"
				prepend-icon="$plus"
				@click="window.location.href='/bo/management/resellers/new'"
			>
				<translate>Add new reseller</translate>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-text-field
						v-model="search"
						append-inner-icon="$search"
						:label="$gettext('Search')"
						single-line
						hide-details
						variant="outlined"
					/>
				</v-col>
				<v-spacer />
			</v-row>
			<v-row>
				<v-col>
					<v-data-table
						:headers="headers"
						:search="search"
						:items="resellers"
					>
						<template #item.name="{ item }">
							<a :href="`/bo/management/resellers/view?id=${item.id}`">
								{{ item.name }}
							</a>
						</template>
						<template #item.domain="{ value }">
							<v-img
								:src="'/images/flags/' + value.toLowerCase() +'.svg'"
								width="32px"
								height="24px"
							/>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import axios from 'axios';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'ResellerPage',
	data () {
		return {
			search: '',
			resellers: []
		};
	},

	computed: {
		/**
		 * @returns {Array} array of headers
		 */
		headers () {
			return [
				{
					title: this.$gettext('Name'), align: 'start', sortable: false, value: 'name'
				},
				{
					title: this.$gettext('White Label'), sortable: false, value: 'white_label', filterable: false
				},
				{
					title: this.$gettext('domain'), sortable: false, value: 'domain', filterable: false
				},
			];
		}
	},

	created () {
		this.getResellers();
	},

	methods: {
		/**
		 * Get all resellers
		 *
		 * @returns {void}
		 */
		getResellers () {
			axios.get('/bo/management/resellers/resellersdata')
				.then(({
					data: data
				}) => {
					this.resellers = data;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during get reseller request'));
				});
		},

		/**
		 * Checks if our language is a flag path or just text.
		 *
		 * @param {string} language - language the email template is.
		 * @returns {boolean} Whether it is a flag path or not
		 */
		ifFile (language) {
			return !!/(?:\.([^.]+))?$/.exec(language)[1];
		},

	}
};
</script>

<style scoped>

</style>
